<template>
  <table-layout title="مدیریت کاربران">
    <template #buttons>
      <router-link :to="{ name: 'User' }">
        <b-button pill variant="purple">لیست کابران</b-button>
      </router-link>
    </template>

    <template #table>
      <user-items :items="trash"></user-items>
      <div class="row pt-3">
        <div class="mt-3 mx-auto color">
          <pagination :meta="paginationMeta" :on-change-page="changePage"/>
        </div>
      </div>
    </template>
  </table-layout>
</template>

<script>
import {mapGetters, mapActions} from "vuex";
import TableLayout from '../TableLayout'
import Pagination from "../Pagination"
import UserItems from "./Items"


export default {
  name: "UserTrash",
  components: {TableLayout, Pagination, UserItems},

  data() {
    return {}
  },
  computed: {
    ...mapGetters({
      trash: "User/getTrash",
      paginationMeta: "User/getPaginationMeta",
    }),
  },
  methods: {
    ...mapActions({
      getTrash: "User/getTrash",
    }),
    changePage(page) {
      this.getTrash(page)
    },
  },
  mounted() {
    this.getTrash()
  },
}
</script>

<style scoped>

</style>